export default "__VITE_ASSET__BM4zOOXc__"